export default "__VITE_ASSET__y_MIF51Z__"